import { ThreeColorTheme } from 'src/types/components';

export const hasNonWhiteTheme = (theme: ThreeColorTheme) => {
  return theme === 'dark' || theme === 'gray';
};
